import { ClickEventComponentNames } from 'features/analytics';
import { logButtonClick } from 'features/navigation/utils/analytics';
import { InteractionManager, StyleSheet } from 'react-native';

import { TAB_BAR_MIN_HEIGHT } from 'navigation/tab-bar-safe-area';
import { primitive } from 'styles/constants';
import { startTrace } from 'utils/performance/trace';
import { TraceName } from 'utils/performance/types';

export const getTabTestId = (name: string) => `nav-with-picture-icon-${name}`;

const createAnalyticsEvent = (name: string, traceName?: TraceName) => ({
  tabPress: () => {
    if (traceName) {
      startTrace(traceName, { tabPress: 'true' });
    }
    InteractionManager.runAfterInteractions(() => {
      logButtonClick({ attributes: { name, component: ClickEventComponentNames.NAV_BAR } });
    });
  },
});

export const tabAnalyticsListeners = {
  index: createAnalyticsEvent('Home', TraceName.HOME_LOAD),
  menu: createAnalyticsEvent('Menu', TraceName.MENU_LOAD),
  'my-code': createAnalyticsEvent('My Code', TraceName.MY_CODE_LOAD),
  offers: createAnalyticsEvent('Offers', TraceName.OFFERS_LOAD),
  rewards: createAnalyticsEvent('Rewards', TraceName.REWARDS_LOAD),
};

// SVG icons, rendered in JS via `expo-image` for the custom (control) tab bar.
export const TAB_ICONS = {
  home: {
    base: require('../../assets/images/nav/home.svg'),
    active: require('../../assets/images/nav/home-active.svg'),
  },
  menu: {
    base: require('../../assets/images/nav/menu.svg'),
    active: require('../../assets/images/nav/menu-active.svg'),
  },
  myCode: {
    base: require('../../assets/images/nav/my-code.svg'),
    active: require('../../assets/images/nav/my-code-active.svg'),
  },
  offers: {
    base: require('../../assets/images/nav/offers.svg'),
    active: require('../../assets/images/nav/offers-active.svg'),
  },
  rewards: {
    base: require('../../assets/images/nav/rewards.svg'),
    active: require('../../assets/images/nav/rewards-active.svg'),
  },
} as const;

// Native tab bars cannot render SVG. Metro picks @2x/@3x PNG variants from these requires.
export const NATIVE_TAB_ICONS = {
  home: {
    base: require('../../assets/images/nav/home.png'),
    active: require('../../assets/images/nav/home-active.png'),
  },
  menu: {
    base: require('../../assets/images/nav/menu.png'),
    active: require('../../assets/images/nav/menu-active.png'),
  },
  myCode: {
    base: require('../../assets/images/nav/my-code.png'),
    active: require('../../assets/images/nav/my-code-active.png'),
  },
  offers: {
    base: require('../../assets/images/nav/offers.png'),
    active: require('../../assets/images/nav/offers-active.png'),
  },
  rewards: {
    base: require('../../assets/images/nav/rewards.png'),
    active: require('../../assets/images/nav/rewards-active.png'),
  },
} as const;

export const tabBarStyles = StyleSheet.create({
  tabBarStyle: {
    backgroundColor: primitive.$mayoEggWhite,
    borderTopColor: '#FFFFFF',
    borderTopWidth: 1,
    minHeight: TAB_BAR_MIN_HEIGHT,
  },
  iconWrapper: {
    alignItems: 'center',
  },
  activeIndicatorContainer: {
    height: 3,
    top: -7,
  },
  activeIndicator: {
    backgroundColor: primitive.$bbqBrown,
    width: 70,
  },
  iconStyles: { height: 22, width: 22 },
  focusedLabelStyle: { fontFamily: 'Flame-Regular', color: primitive.$bbqBrown, fontSize: 12 },
  unfocusedLabelStyle: { fontFamily: 'Flame-RegularSans', color: '#82685B', fontSize: 12 },
});

export const nativeTabLabelStyle = {
  default: {
    fontFamily: tabBarStyles.unfocusedLabelStyle.fontFamily,
    fontSize: tabBarStyles.unfocusedLabelStyle.fontSize,
  },
  selected: {
    color: tabBarStyles.focusedLabelStyle.color,
    fontFamily: tabBarStyles.focusedLabelStyle.fontFamily,
    fontSize: tabBarStyles.focusedLabelStyle.fontSize,
  },
};

export const nativeTabSelectedLabelStyle = {
  color: tabBarStyles.focusedLabelStyle.color,
};

export const nativeTabContentStyle = { backgroundColor: primitive.$mayoEggWhite };

export const myCodeNativeTabProps = {
  scrollEdgeEffects: {
    bottom: 'hidden' as const,
    left: 'hidden' as const,
    right: 'hidden' as const,
  },
};
